module.exports = __webpack_public_path__ + "static/media/wand.4d8e3953.svg";